<template>
  <transition name="slide">
    <div
      :class="s.container"
      v-if="notice.name && user.login.isLogin"
      @click="clicked">
      <div :class="s.content">
        <div
          v-if="!notice.autoClose"
          :class="s.close">
          <div @click="closeNotice"><i class="fa-regular fa-xmark"/></div>
        </div>
        <component :is="notice.name"/>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex';
import DispatchRequest from './contents/DispatchRequest.vue';
import RequestCanceled from './contents/RequestCanceled.vue';
import ReservationConfirmed from './contents/ReservationConfirmed.vue';
import ReceiveMessage from './contents/ReceiveMessage.vue';

export default {
  name: 'notice',
  components: {
    DispatchRequest,
    RequestCanceled,
    ReservationConfirmed,
    ReceiveMessage,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState(['notice', 'user']),
  },
  methods: {
    closeNotice() {
      const args = { name: '' };
      this.$store.dispatch('notice/setNotice', args, { root: true });
    },
    clicked() {
      if (this.notice.link) this.$router.push(this.notice.link);
    },
  },
};
</script>

<style lang="scss" module="s">
.container {
  position: fixed;
  top: 12px;
  left: 12px;
  z-index: 200;
  border-radius: 12px;
  background-color: #ffffff;
  padding: 32px;
  width: calc(100vw - 24px);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.content {
  position: relative;
  overflow: scroll;
}
.close {
  position: relative;
  width: 100%;
  > * {
    position: absolute;
    top: 0;
    left: 100%;
    line-height: 1;
    transform: translate(-50%, -50%);
    font-size: 20px;
  }
}
</style>
